var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeSlotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 2C18.014 2 22.5 6.486 22.5 12C22.5 17.514 18.014 22 12.5 22C6.986 22 2.5 17.514 2.5 12C2.5 6.486 6.986 2 12.5 2ZM12.5 3.5C7.813 3.5 4 7.313 4 12C4 16.687 7.813 20.5 12.5 20.5C17.187 20.5 21 16.687 21 12C21 7.313 17.187 3.5 12.5 3.5ZM12.1612 7.0954C12.5762 7.0954 12.9112 7.4314 12.9112 7.8454V12.2674L16.3162 14.2974C16.6712 14.5104 16.7882 14.9704 16.5762 15.3264C16.4352 15.5614 16.1862 15.6924 15.9312 15.6924C15.8002 15.6924 15.6682 15.6584 15.5472 15.5874L11.7772 13.3384C11.5512 13.2024 11.4112 12.9574 11.4112 12.6934V7.8454C11.4112 7.4314 11.7472 7.0954 12.1612 7.0954Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSlotIcon);
export default __webpack_public_path__ + "static/media/timeSlot-icon.0bef78d74ff6997b8da2ca09d2b0a0ee.svg";
export { ForwardRef as ReactComponent };